import Vue from "vue";
import Vuex from "vuex";
import http from "../../service/data-service";

export default {
  state: {
    last10: null,
    estatisticas: null
  },
  getters: {
    last10(state: any) {
      return state.last10;
    },
    estatisticas(state: any) {
      return state.estatisticas;
    },
  },
  mutations: {
    setLast10(state: any, last10: any) {
      state.last10 = last10;
    },
    setEstatisticas(state: any, estatisticas: any) {
      state.estatisticas = estatisticas;
    },
  },
  actions: {
    findLast10Concursos({ commit }: { commit: any }) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/concurso/findLast10Concursos/lotofacil")
          .then((result: any) => {
            commit("setLast10", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    findEstatisticas({ commit }: { commit: any }) {
      return new Promise((resolve, reject) => {
        http
          .get("/api/v1/estatistica/findEstatisticas/")
          .then((result: any) => {
            commit("setEstatisticas", result.data);
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    },
    saveEstatistica ({ commit }: { commit: any }, payload : any) {
      return new Promise((resolve, reject) => {
        http
          .post("/api/v1/estatistica/save/", payload)
          .then((result: any) => {
            resolve(result.data);
          })
          .catch((err: any) => {
            commit("setError", err.response || err);
            try {
              reject(err.response.data.error);
            } catch (e) {
              reject(err);
            }
          });
      });
    }

  },
};
